import { getJsNow } from 'utils/date';
import dealService from 'resources/deal/deal.service';
import dealEventService from 'resources/deal-event/deal-event.service';
import * as userOperations from 'resources/user/user.operations';
import { DEAL_ENDED_STATUSES } from 'resources/deal/deal.constants';
import { DEAL_EVENT_TYPES } from 'resources/deal-event/deal-event.constants';


export const finishTransaction = async (deal, status, userId) => {
  const updatedDeal = await dealService.updateDeal({
    id: deal.id,
    status,
    transaction: {
      ...deal.transaction,
      finished_on: getJsNow(),
    },
  });

  if (userId) {
    await dealEventService.createDealEvent({
      type: status === DEAL_ENDED_STATUSES.CLOSED ? DEAL_EVENT_TYPES.COMPLETED : DEAL_EVENT_TYPES.VOIDED,
      dealId: deal.id,
      companyId: deal.company_id,
      createdBy: userId,
    });
  }

  await Promise.all(deal.client_ids.map((clientId) => userOperations.actualizeClientStatusAndRoles(clientId)));

  return updatedDeal;
};
